import React, { useRef } from "react";

import Slider from "@/components/Atoms/Slider";

import SlickArrowButton from "@/components/Molecules/SlickArrowButton";

import TestimonialCard from "./TestimonialCard";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./Testimonials.module.scss";

interface TestimonialsProps {
  heading?: string;
  headingMobile?: string;
  unslickWidth?: number;
  testimonies: {
    profilePicture: string;
    heading: string;
    review: string;
    customer: {
      name: string;
      duration: string;
    };
  }[];
  className?: string;
}

const Testimonials: React.FC<TestimonialsProps> = ({ 
  testimonies,
  className=""
 }) => {
  const sliderRef = useRef(null);

  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <SlickArrowButton
        buttonType="prev"
        variant="icon1"
        icon="icon-Secondary-Cricle-Button"
      />
    ),
    nextArrow: (
      <SlickArrowButton
        buttonType="next"
        variant="icon1"
        icon="icon-Secondary-Cricle-Button-next"
      />
    ),
  };

  const cls = classNameGenerator(styles);

  if (!testimonies?.length) {
    return <></>;
  }

  return (
    <section className={clsx(cls("testimonials"),cls(className))}>
      <div className={cls("container")}>
        <Slider ref={sliderRef} settings={settings}>
          {testimonies?.map((testimony, index) => (
            <TestimonialCard className={className}  key={index} {...testimony} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
